module.exports = ".table-testata .mat-cell:nth-child(1), .table-testata .mat-header-cell:nth-child(1) {\n  display: none;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/testata/testata-search/testata-search.component.css
// module id = ./src/app/components/testata/testata-search/testata-search.component.css
// module chunks = main